/** CTA label for a course card's primary action button, keyed off the
 *  learner's {@code attendeeStatus}: not yet started → "start", in
 *  progress or any other in-between state → "continue", finished →
 *  "retake". */
export function courseCtaLabel(
  t: (key: string) => string,
  attendeeStatus: string | undefined,
  approvalRequired?: boolean,
): string {
  if (approvalRequired) return t('button.request');
  if (!attendeeStatus) return t('label.startLearning');
  if (attendeeStatus === 'REGISTERED') return t('label.startLearning');
  if (!['COMPLETED', 'IN_PROGRESS'].includes(attendeeStatus ?? ''))
    return t('label.continueLearning');
  return t('label.startLearning');
}
